import * as icons from 'react-bootstrap-icons';

export const MenuItems = [
    {
        title: "داشبورد",
        icon: <icons.Speedometer2 size={20}/>,
        action: '/dashboard',
        active: true,
        pageIndex: 0,
        acin: [0, 0],
    },{
        title: "لیست بیماران",
        icon: <icons.PersonLinesFill size={20}/>,
        action: '/dashboard/patients',
        active: true,
        pageIndex: 2,
        acin: [2, 0],
    },{
        title: "لیست کاربران",
        icon: <icons.Person size={20}/>,
        action: '/dashboard/users',
        active: true,
        pageIndex: 1,
        acin: [3, 0],
    },{
        title: "تنظیمات",
        icon: <icons.Gear size={20}/>,
        action: '/dashboard/setting',
        active: true,
        pageIndex: 4,
        acin: [4, 0]
    },{
        title: "لیست نوبت‌ها",
        icon: <icons.CardList size={20}/>,
        action: '/dashboard/',
        active: false,
        pageIndex: 5,
        acin: 0,
    },{
        title: "خروج",
        icon: <icons.DoorOpen size={20}/>,
        action: '/',
        active: true,
        pageIndex: 3,
        acin: 0,
    }
]